/**
 * @file 组件初始化入口
 */

import TList from './list.vue'
import TListItem from './list-item.vue'
import TListGroup from './list-group.vue'

TList.install = Vue => {
  Vue.component(TList.name, TList)
}
TListItem.install = Vue => {
  Vue.component(TListItem.name, TListItem)
  Vue.component('TOption', TListItem)
}
TListGroup.install = Vue => {
  Vue.component(TListGroup.name, TListGroup)
  Vue.component('TOptionGroup', TListGroup)
}

export {
  TList,
  TListItem,
  TListItem as TOption,
  TListGroup,
  TListGroup as TOptionGroup
}



// WEBPACK FOOTER //
// ./src/module/list/index.js